export default __webpack_public_path__ + "static/media/spinner.8cb2df25.png";